export type AIProviderSlug = "openai" | "anthropic" | "gemini";

const PROVIDER_LABELS: Record<string, string> = {
  openai: "OpenAI",
  anthropic: "Claude",
  gemini: "Gemini",
};

/** Retorna o label amigável do provedor para exibição na UI. O slug permanece inalterado na persistência. */
export function getProviderDisplayLabel(slug: string | null | undefined): string {
  if (!slug) return "-";
  return PROVIDER_LABELS[slug] ?? slug.charAt(0).toUpperCase() + slug.slice(1);
}

export const providerOptions: { value: AIProviderSlug; display: string }[] = [
  { value: "openai", display: "OpenAI" },
  { value: "anthropic", display: "Claude" },
];

export interface ProviderConfig {
  slug: AIProviderSlug;
  label: string;
  description: string;
  apiKeyUrl: string;
  helpText: string;
}

export const providerConfigs: ProviderConfig[] = [
  {
    slug: "openai",
    label: "OpenAI",
    description: "Modelos GPT para geração de texto e análise clínica.",
    apiKeyUrl: "https://platform.openai.com/api-keys",
    helpText:
      "Crie uma chave em platform.openai.com. Você precisará de uma conta OpenAI com créditos disponíveis.",
  },
  {
    slug: "anthropic",
    label: "Claude",
    description: "Modelos Claude da Anthropic para raciocínio clínico avançado.",
    apiKeyUrl: "https://console.anthropic.com/settings/keys",
    helpText:
      "Gere uma chave em console.anthropic.com. É necessário ter uma conta Anthropic ativa.",
  },
];

/** Mascara uma chave de API para exibição segura (ex.: sk-...x7Kq). */
export function maskApiKey(key: string): string {
  if (!key || key.length <= 8) return "••••••••";
  return `${key.slice(0, 3)}...${key.slice(-4)}`;
}
